<template>
  <div class="wrap embedded-survey-wrap" v-if="isLoading">
    <Loading :visible="isLoadingPop"></Loading>
    <div class="top-header">
      <incBack></incBack>
    </div>
    <div class="body-wrap">
      <h6>어떤 고민에 집중하고 싶으신가요?</h6>
      <h4>순서대로 선택해 주세요!</h4>
      <span class="survey-info">최소 2개 이상 선택해 주세요</span>
      <VueSlickCarousel v-if="list.length" @afterChange="onAfterChange" :adaptiveHeight="true" :swipe="false" :arrows="false" :dots="false" ref="carousel" :infinite="false">
        <div v-for="(item, index) in list" :key="index">
          <ul class="pb-50 main-slide">
            <li v-for="(subItem, subIndex) in item.sub_list" :key="subIndex" class="clear" :class="{ active: subItem.is_active }">
              <div class="float-left ball" @click="selectItem(index, subItem)">
                <span v-if="subItem.is_active"
                  ><b>{{ subItem.order }}</b></span
                >
              </div>
              <p class="float-left" v-if="subItem.categorySubject != '기타'" v-html="subItem.categoryContent" @click="selectItem(index, subItem)"></p>
              <div class="float-left w-100per other" v-else>
                <p @click="selectItem(index, subItem)">{{ subItem.categorySubject }}</p>
                <textarea class="w-80per" :placeholder="subItem.categoryContent" v-if="subItem.is_other" v-model="input.etcMemo"></textarea>
              </div>
            </li>
          </ul>
          <ul class="dots">
            <li v-for="(item, index) in activeData" :key="index" :class="{ active: index == currentSlide }">
              <button></button>
            </li>
          </ul>
          <div class="bnb-btn">
            <button @click="showNext()" :class="{ active: is_active }" v-if="currentSlide != list.length - 1">NEXT</button>
            <button @click="showNext()" :class="{ active: is_active }" v-else>결과보기</button>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import incBack from "@/components/inc/inc_back.vue";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "embedded_survey_subject",
  data: () => ({
    sampleData: "abc",
    isAxiosRun: false,
    currentSlide: 0,
    list: [],
    selectData: [[], [], []],
    activeData: [],
    is_active: false,
    isLoading: false,
    input: {
      depth: "2",
      categoryIdxList: [],
      userIdx: 1,
      courseIdx: 1,
      categoryParent: 0,
      etcMemo: "",
    },
    isLoadingPop: false,
  }),
  components: {
    VueSlickCarousel,
    incBack,
    Loading,
  },
  mounted() {
    console.log(localStorage.getItem("mainSurveyData"));
    this.getList();
    //    console.log(this.selectData[0][0].length);
  },
  methods: {
    selectItem(index, subItem) {
      console.log(subItem);
      if (!subItem.is_active) {
        this.selectData[index].push(subItem);
        this.list[index].count++;
        if (subItem.categorySubject == "기타") {
          subItem.is_other = true;
          this.input.etcMemo = "";
        }
      } else {
        let find_idx = this.selectData[index].findIndex((obj) => obj.categoryIdx == subItem.categoryIdx);
        this.selectData[index].splice(find_idx, 1);
        this.list[index].count--;
        if (subItem.categorySubject == "기타") {
          subItem.is_other = false;
          subItem.other_content = "";
        }
      }

      for (let i = 0; i < this.list[index].sub_list.length; i++) {
        if (this.selectData[index].length > 0) {
          for (let j = 0; j < this.selectData[index].length; j++) {
            if (this.list[index].sub_list[i].categoryIdx == this.selectData[index][j].categoryIdx) {
              this.list[index].sub_list[i].is_active = true;
              this.list[index].sub_list[i].order = j + 1;
              break;
            } else {
              this.list[index].sub_list[i].is_active = false;
              this.list[index].sub_list[i].order = 0;
            }
          }
        } else {
          this.list[index].sub_list[i].is_active = false;
          this.list[index].sub_list[i].order = 0;
        }
      }
      if (this.list[index].count < 2) {
        this.is_active = false;
      } else {
        this.is_active = true;
      }
    },
    getList() {
      this.list = [];
      this.axios
        .get("/front/embedded-survey-list")
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            // 대분류 저장 데이터
            this.activeData = JSON.parse(localStorage.getItem("mainSurveyData"));
            console.log("activedata", this.activeData);

            //소분류 저장 데이터
            if (localStorage.getItem("subSurveyData") != "null" && localStorage.getItem("subSurveyData") != "" && localStorage.getItem("subSurveyData") != null) {
              this.selectData = JSON.parse(localStorage.getItem("subSurveyData"));
              this.is_active = true;
            }
            let embedded_data = res.data.data;
            let sub_list = [];
            let count = 0;
            if (this.activeData) {
              for (let i = 0; i < this.activeData.length; i++) {
                sub_list = [];
                count = 0;
                for (let j = 0; j < embedded_data.length; j++) {
                  if (this.activeData[i].value == embedded_data[j].categoryParent) {
                    embedded_data[j].is_active = false;
                    embedded_data[j].order = 0;
                    embedded_data[j].is_other = false;
                    embedded_data[j].other_content = "";
                    if (localStorage.getItem("subSurveyData") != "null" && localStorage.getItem("subSurveyData") != "" && localStorage.getItem("subSurveyData") != null) {
                      for (let select_index = 0; select_index < this.selectData.length; select_index++) {
                        for (let select_subIndex = 0; select_subIndex < this.selectData[select_index].length; select_subIndex++) {
                          if (embedded_data[j].categoryIdx == this.selectData[select_index][select_subIndex].categoryIdx) {
                            embedded_data[j] = this.selectData[select_index][select_subIndex];
                            count++;
                          }
                        }
                      }
                    } else {
                      this.selectData = [[], [], []];
                    }
                    sub_list.push(embedded_data[j]);
                  }
                }
                this.list.push({ sub_list: sub_list, count: count });
              }
            }

            this.isLoading = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showNext() {
      if (this.is_active) {
        if (this.list[this.currentSlide].count < 2) {
          alert("2개이상 선택해주세요.");
          return false;
        } else {
          if (this.currentSlide == this.list.length - 1) {
            this.isLoadingPop = true;
          } else {
            this.isLoadingPop = false;
          }

          this.input.userIdx = this.$store.state.userInfo.userIdx;
          this.input.courseIdx = this.$store.state.courseInfo.courseIdx;

          let otherList = ["11", "16", "21", "26", "33", "38"];
          this.input.categoryIdxList = [];
          let isEtc = false;
          for (let item of this.selectData[this.currentSlide]) {
            if (otherList.includes(item.categoryIdx)) {
              isEtc = true;
            }
            this.input.categoryIdxList.push(item.categoryIdx);
          }
          if (isEtc) {
            if (this.input.etcMemo == "") {
              alert("기타 내용을 입력해주세요.");
              this.isLoadingPop = false;
              return false;
            }
          }

          localStorage.setItem("subSurveyData", JSON.stringify(this.selectData));
          // this.input.categoryIdxList = [];
          this.input.categoryParent = this.activeData[this.currentSlide].value;
          let params = this.input;
          // console.log(params);
          this.axios
            .post("/front/embedded-survey-insert", params)
            .then((res) => {
              if (res.data.success) {
                if (this.currentSlide == this.list.length - 1) {
                  this.isLoadingPop = true;
                  this.$router.push({ name: "embedded_survey_result", params: { view: 0 } });
                } else {
                  this.isLoadingPop = false;
                  this.input.etcMemo = "";
                  window.scrollTo(0, 0);
                  this.$refs.carousel.next();
                  if (this.selectData[this.currentSlide++].length < 2) {
                    this.is_active = false;
                  } else {
                    this.is_active = true;
                  }
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    onAfterChange(slideIndex) {
      this.currentSlide = slideIndex;
    },
  },
};
</script>
